import http from "../../httpService";

const apiEndpoint = "/manage/zoom/room";

export function getZoomRoomList(input) {
  const query = (input) ? Object.keys(input).map(key=> { return `${key}=${input[key]}`}).join('&') : ''

  return http.get(apiEndpoint + ((query) ? '/?' + query : ''))
}

export function getZoomRoom(id) {
  return http.get(apiEndpoint + "/" + id);
}

export function saveZoomRoom(doc) {
  if (doc._id) {
    const body = { ...doc };
    delete body._id;
    return http.put(apiEndpoint + "/" + doc._id, body);
  }

  return http.post(apiEndpoint , doc )
}

export function setZoomRoomEnable({_id, enable}) {
  return http.put(apiEndpoint + "/" + _id + "/enable", { enable })
}

export function deleteZoomRoom(id) {
  return http.delete(apiEndpoint + "/" + id);
}